"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInfoId = void 0;
const getInfoId = (id) => `${id}-info`;
exports.getInfoId = getInfoId;
//# sourceMappingURL=index.js.map